export const asREM = (pixels: number) => `${pixels / 16}rem`;
